import { Component } from '@angular/core';

@Component({
  selector: 'app-ep-card-footer',
  templateUrl: './ep-card-footer.component.html',
  styleUrls: ['./ep-card-footer.component.scss']
})
export class EpCardFooterComponent {}
